import type { SubmitQuizInput } from '@/types';
import type { AnswerValue } from './question-card';

// Respuestas del formulario → cuerpo del envío. Extraído de attempt.tsx por ENG-LOC-01.
export function buildSubmitPayload(answers: Record<number, AnswerValue>): SubmitQuizInput {
  return {
    answers: Object.entries(answers).map(([qId, val]) => {
      const base = { question_id: Number(qId) };
      if (val.kind === 'choice') return { ...base, choice_id: val.choice_id };
      if (val.kind === 'multi') return { ...base, choice_ids: val.choice_ids };
      return { ...base, written_answer: val.text };
    }),
  };
}
